<template>
  <div class="container">
    <div class="flex flex-row-left margin-top-20">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="订单号相关">
            <el-input
              style="width: 200px"
              v-model="formInline.platformName"
              placeholder="马帮订单或交易号"
              clearable
            />
          </el-form-item>
          <el-form-item label="zoho订单">
            <el-input
              style="width: 200px"
              v-model="formInline.zohoId"
              placeholder="zoho订单"
              clearable
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              @clear="formInline.isSend = ''"
              style="width: 200px"
              v-model="formInline.isSend"
              clearable
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
          :max-height="dynamicHeight"
          :data="tableData"
          :preserve-expanded-content="true"
          :stripe="true"
          :border="true"
          :highlight-current-row="true"
          size="default"
        >
          <el-table-column
            label="马帮订单号"
            min-width="150"
            prop="PlatformOrderId"
          ></el-table-column>
          <el-table-column
            label="马帮交易号"
            min-width="100"
            prop="salesRecordNumber"
          ></el-table-column>
          <el-table-column
            label="sku"
            min-width="120"
            prop="sku"
          ></el-table-column>
          <el-table-column
            label="店铺ID"
            min-width="160"
            prop="shopId"
          ></el-table-column>
          <el-table-column
            label="状态"
            min-width="80"
            prop="isSend"
          >
            <template #default="scope">
              <span v-if="scope.row.isSend === 0">未推送</span>
              <span v-else-if="scope.row.isSend === 1">已推送</span>
              <span v-else-if="scope.row.isSend === 2">已删除</span>
              <span v-else>{{ scope.row.isSend }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Zoho订单号"
            min-width="170"
            prop="ZohoId"
          >
            <template #default="scope">
              <a 
                v-if="scope.row.ZohoId" 
                :href="'https://crm.zoho.com/crm/org853922543/tab/CustomModule7/' + scope.row.ZohoId" 
                target="_blank"
                rel="noopener noreferrer"
                class="zoho-link"
              >
                {{ scope.row.ZohoId }}
              </a>
              <span v-else>{{ scope.row.ZohoId }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="重试次数"
              min-width="80"
              prop="retry_count"
          ></el-table-column>
          <el-table-column
            label="备注"
            min-width="190"
            prop="remake"
          >
            <template #default="scope">
              <div class="remark-cell" :title="scope.row.remake">
                {{ scope.row.remake }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="发送参数"
            min-width="150"
            prop="others"
          >
            <template #default="scope">
              <div class="others-cell" :title="formatOthersTitle(scope.row.others)">
                <div v-for="(value, key) in formatOthersData(scope.row.others)" :key="key" class="others-item">
                  {{ key }}: {{ value }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            min-width="150"
            prop="CreateTime"
          ></el-table-column>
          <el-table-column
            label="推送时间"
            min-width="150"
            prop="UpdateTime"
          ></el-table-column>
          <el-table-column
            label="操作"
            min-width="100"
          >
            <template #default="scope">
              <el-button
                type="danger"
                size="small"
                :disabled="scope.row.isSend === 2 || !scope.row.ZohoId"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="pageTotal"
          :page-sizes="[10, 20, 30, 50]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          layout="total, sizes, prev, pager, next"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElPagination,
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption
} from "element-plus";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import { ZohoCrm, deleteZohoCrm } from "@/utils/api";

export default {
  name: "shopifyTozoho",
  components: {
    ElForm,
    ElFormItem,
    ElButton,
    ElInput,
    ElTable,
    ElTableColumn,
    ElPagination,
    ElSelect,
    ElOption
  },
  mixins: [DynamicHeightMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      pageTotal: 0,
      formInline: {
        platformName: "",
        zohoId: "",
        isSend: ""
      },
      tableData: [],
      statusOptions: [
        {
          value: 0,
          label: "未推送"
        },
        {
          value: 1,
          label: "已推送"
        },
        {
          value: 2,
          label: "已删除"
        }
      ]
    };
  },
  mounted() {
    this.getZohoCrmData();
  },
  methods: {
      onSubmit() {
        this.currentPage = 1;
        this.getZohoCrmData();
      },
      getZohoCrmData() {
        const params = {
          PageNumber: this.currentPage,
          PageSize: this.pageSize,
          ...this.formInline
        };
        
        ZohoCrm(params)
          .then(res => {
            console.log(res);
            this.tableData = res.Data || [];
            this.pageTotal = res.Total || 0;
          })
          .catch(err => {
            console.error(err);
            this.tableData = [];
            this.pageTotal = 0;
          });
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getZohoCrmData();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getZohoCrmData();
      },
      // 格式化others字段数据，返回键值对对象
      formatOthersData(others) {
        if (!others || typeof others !== 'object') {
          return {};
        }
        // 只取前3个键值对
        const keys = Object.keys(others);
        const result = {};
        const limit = Math.min(keys.length, 3);
        for (let i = 0; i < limit; i++) {
          const key = keys[i];
          result[key] = others[key];
        }
        return result;
      },
      // 格式化others字段的title属性，用于鼠标悬浮显示完整内容
      formatOthersTitle(others) {
        if (!others || typeof others !== 'object') {
          return '';
        }
        return Object.entries(others)
          .map(([key, value]) => `${key}: ${value}`)
          .join('\n');
      },
      // 删除Zoho订单
      handleDelete(row) {
        // 确认删除
        this.$confirm('确定要删除这个Zoho订单吗？', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            zohoId: row.ZohoId
          };
          
          deleteZohoCrm(params)
            .then(res => {
              console.log(res);
              if (res.Code === 200) {
                // 删除成功，重新加载数据
                this.getZohoCrmData();
                this.$message.success('删除成功');
              } else {
                this.$message.error('删除失败：' + res.Message);
              }
            })
            .catch(err => {
              console.error(err);
              this.$message.error('删除失败：' + err.message);
            });
        }).catch(() => {
          // 用户取消删除
          this.$message.info('已取消删除');
        });
      }
    }
  };
</script>

<style scoped>
.container {
  width: 92%;
  margin: 0 auto;
}

::v-deep .container .el-form-item {
  margin-bottom: 0 !important;
}

.remark-cell {
  height: 60px; /* 固定高度，大约3行文字的高度 */
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
}

.others-cell {
  height: 60px; /* 固定高度，大约3行文字的高度 */
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
}

.others-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zoho-link {
  color: #409eff;
  text-decoration: none;
}

.zoho-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}
</style>